import { Box } from "@mui/material";
import { IWebTicket } from "../../interfaces";
import TicketUpsale from "./Upsale/TicketUpsale";

type TicketUpsalesProps = {
    ticket: IWebTicket;
};

export const TicketUpsales = ({ ticket }: TicketUpsalesProps) => {
    if (ticket.upsales.length === 0) {
        return null; // Don't render anything if there are no upsales
    }

    return (
        <Box display="flex" flexDirection="column" gap={1}>
            {ticket.upsales.map((upsale) => (
                <TicketUpsale
                    key={`ticket-${ticket.id}-upsale-${upsale.id}`}
                    upsale={upsale}
                    ticket={ticket}
                />
            ))}
        </Box>
    );
};
